module.exports = "tr.td-data-table-row {\n  height: 80px; }\n\n.HandCursor {\n  cursor: pointer; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/consulta/hojadeseguimiento/exploracion/exploracion.component.scss
// module id = ./src/app/consulta/hojadeseguimiento/exploracion/exploracion.component.scss
// module chunks = main